/*
 * @Author: lbh
 * @Date: 2023-08-17 10:44:25
 * @LastEditors: lbh
 * @LastEditTime: 2024-10-08 11:02:45
 * @Description: file content
 */
import Fingerprint2 from "fingerprintjs2";

export default () => {
  return new Promise((a, b) => {
    let userMur = localStorage.getItem("ricepos_user_murmur");
    if (!userMur) {
      Fingerprint2.get(function (components) {
        const values = components.map(function (component, index) {
          if (index === 0) {
            //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
            return component.value.replace(/\bNetType\/\w+\b/, "");
          }
          return component.value;
        });
        // 生成最终id murmur
        const murmur = Fingerprint2.x64hash128(values.join(""), 31);
        localStorage.setItem("ricepos_user_murmur", murmur);
        a(murmur);
      });
    } else a(userMur);
  });
};
